import React from 'react';
import { Repeat } from 'lucide-react';

const cardStyle = {
  background: '#FFFFFF',
  borderRadius: 18,
  padding: 14,
  border: '1px solid rgba(112, 63, 246, 0.08)',
  boxShadow: 'var(--premium-shadow-nested)',
  overflowX: 'auto',
};

const headerCell = {
  fontSize: 11,
  fontWeight: 700,
  color: '#999',
  textTransform: 'uppercase',
  letterSpacing: 0.8,
  padding: '8px 10px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

const cellStyle = (pct) => {
  if (pct === null || pct === undefined) {
    return { padding: '8px 10px', textAlign: 'center', fontSize: 12, color: '#bbb' };
  }
  const intensity = Math.min(1, Math.max(0, pct / 60));
  const bg = `rgba(0, 179, 65, ${0.07 + intensity * 0.55})`;
  return {
    padding: '8px 10px',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 600,
    color: pct >= 40 ? '#FFFFFF' : '#0D682C',
    background: bg,
    borderRadius: 6,
  };
};

export const RetentionTable = ({ data, loading }) => {
  const rows = Array.isArray(data) ? data : [];
  const maxColumns = rows.reduce((acc, r) => Math.max(acc, r.retention.length), 0);

  return (
    <div style={cardStyle} data-testid="retention-table-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <Repeat size={16} color="var(--accent-purple-strong)" />
        <h3 style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, fontWeight: 700, margin: 0, color: '#000', flex: 1 }}>Guest retention by cohort</h3>
        <span style={{ fontSize: 11, color: '#aaa' }}>% who booked again in later months</span>
      </div>
      {loading && rows.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999', padding: 20, fontSize: 13 }}>Loading…</p>
      ) : rows.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999', padding: 20, fontSize: 13 }}>No cohort data yet.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 6 }} data-testid="retention-table">
          <thead>
            <tr>
              <th style={{ ...headerCell, textAlign: 'left' }}>Cohort</th>
              <th style={headerCell}>Size</th>
              {Array.from({ length: maxColumns }).map((_, idx) => (
                <th key={idx} style={headerCell}>M+{idx + 1}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.cohort}>
                <td style={{ fontSize: 12, fontWeight: 700, color: '#333', padding: '8px 10px' }}>{row.cohort}</td>
                <td style={{ ...headerCell, color: '#555' }}>{row.size}</td>
                {Array.from({ length: maxColumns }).map((_, idx) => {
                  const entry = row.retention[idx];
                  if (!entry) {
                    return <td key={idx} style={cellStyle(null)}>—</td>;
                  }
                  return (
                    <td key={entry.month} style={cellStyle(entry.percent)} title={`${entry.count} of ${row.size} returned`}>
                      {entry.percent === null ? '—' : `${entry.percent}%`}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
